import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import TextModal from "@coworker/apprestructured/src/task-management/components/TextModal/TextModal";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

const InfoPlaceholder = () => (
  <FixaText tagName="p" textStyle="Body.S">
    (optional) Image or SVG goes here
  </FixaText>
);

function TextModalDemo() {
  const [text, setText] = useState<string>("");
  const [title, setTitle] = useState<string>("Date stamp");
  const [inputLabel, setInputLabel] = useState<string>("YYWW");
  const [disabled, setDisabled] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [numericOnly, setNumericOnly] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const handleConfirmClick = useCallback((newText: string) => {
    setText(newText);
  }, []);

  return (
    <Demo>
      <Name>TextModal</Name>
      <Highlight>
        <FixaListView id="textmodal" size="small">
          <TextModal
            title={title}
            text={text}
            onConfirmClick={handleConfirmClick}
            disabled={disabled}
            maxLength={255}
            inputLabel={inputLabel || undefined}
            numericOnly={numericOnly}
            inputHintText={showHint ? "Format: YYWW, e.g. 2513" : undefined}
            informationTitle={showInfo ? "Where to find it" : undefined}
            informationBody={showInfo ? <InfoPlaceholder /> : undefined}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="textmodal-disabled"
          id="textmodal-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaCheckbox
          label="numericOnly"
          value="textmodal-numeric"
          id="textmodal-numeric"
          checked={numericOnly}
          onChange={() => setNumericOnly((prev) => !prev)}
        />
        <FixaCheckbox
          label="Show input hint text"
          value="textmodal-hint"
          id="textmodal-hint"
          checked={showHint}
          onChange={() => setShowHint((prev) => !prev)}
        />
        <FixaCheckbox
          label="Show additional info in modal"
          value="textmodal-info"
          id="textmodal-info"
          checked={showInfo}
          onChange={() => setShowInfo((prev) => !prev)}
        />
        <FixaInputField
          id="textmodal-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
        <FixaInputField
          id="textmodal-inputlabel"
          value={inputLabel}
          onChange={(e) => setInputLabel(e.target.value)}
          type="text"
          label="inputLabel"
        />
      </Actions>
    </Demo>
  );
}

export default memo(TextModalDemo);
